export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10706.c32bec08.jpg";